import type { ProxyFormFields, ProxyStats, ProxySortBy, ProxySortOrder } from './proxies-manager.types';

export const INITIAL_PROXY_FORM_FIELDS: ProxyFormFields = {
  ip: '',
  port: '',
  username: '',
  password: '',
  country: '',
  provider: '',
};

export const EMPTY_PROXY_STATS: ProxyStats = {
  total: 0,
  available: 0,
  inUse: 0,
  disabled: 0,
  byCountry: {},
};

export const DEFAULT_SORT_BY: ProxySortBy = 'createdAt';
export const DEFAULT_SORT_ORDER: ProxySortOrder = 'desc';

export const DEFAULT_ITEMS_PER_PAGE = 10;
export const MAX_VISIBLE_PAGES = 5;
export const DEFAULT_BULK_COUNTRY = 'US';
